import styled from 'styled-components';

export const MainContent = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
